import { cancelRequest } from "../core/request-coordinator.js";
import {
  chooseTurnDetailArtifactID,
  createTurnDetailState
} from "../domain/turn-detail.js";
import { resolveRunState } from "../domain/conversation.js";

const timerDeps = {
  clearTimeout: globalThis.clearTimeout.bind(globalThis)
};

export function cancelTurnDetailRequests(state) {
  if (!state?.requests) {
    return;
  }
  cancelRequest(state.requests.snapshot);
  cancelRequest(state.requests.artifactBody);
}

export function clearTurnDetailLiveState(state, deps = timerDeps) {
  if (state?.live?.snapshotTimer) {
    deps.clearTimeout(state.live.snapshotTimer);
    state.live.snapshotTimer = null;
  }
  if (state?.live?.streamAbort) {
    state.live.streamAbort.abort();
    state.live.streamAbort = null;
  }
}

export function resetTurnDetailState(state) {
  clearTurnDetailLiveState(state);
  cancelTurnDetailRequests(state);
  applyTurnDetailState(state, createTurnDetailState());
}

export function applyTurnRefreshSnapshot(state, snapshot) {
  state.turn = mergeTurnDetailRecord(state.turn, snapshot.turn);
  state.turnDiagnostics = snapshot.turnDiagnostics;
  state.workspaceDiagnostics = snapshot.workspaceDiagnostics;
  state.artifacts = snapshot.artifacts;
  state.decisions = snapshot.decisions;
  const nextSelectedArtifactID = chooseTurnDetailArtifactID(state.selectedArtifactID, snapshot.artifacts);
  if (nextSelectedArtifactID !== state.selectedArtifactID) {
    cancelRequest(state.requests.artifactBody);
    state.artifactBody = "";
    state.artifactError = "";
  }
  state.selectedArtifactID = nextSelectedArtifactID;
  if (snapshot.events) {
    state.events = snapshot.events;
    state.eventSeqs = new Set(snapshot.events.map((item) => item.seq));
  }
  state.notFound = false;
}

export function applyTurnDetailState(state, nextState) {
  state.turn = nextState.turn;
  state.turnDiagnostics = nextState.turnDiagnostics;
  state.workspaceDiagnostics = nextState.workspaceDiagnostics;
  state.events = nextState.events;
  state.eventSeqs = nextState.eventSeqs;
  state.artifacts = nextState.artifacts;
  state.decisions = nextState.decisions;
  state.selectedArtifactID = nextState.selectedArtifactID;
  state.artifactBody = nextState.artifactBody;
  state.artifactError = nextState.artifactError;
  state.streamState = nextState.streamState;
  state.notFound = nextState.notFound;
  state.activeTab = nextState.activeTab;
  if (!state.live) {
    state.live = createTurnDetailState().live;
  } else {
    state.live.streamAbort = null;
    state.live.snapshotTimer = null;
  }
  if (!state.requests) {
    state.requests = createTurnDetailState().requests;
  }
}

export function buildNotFoundTurnDetailState(activeTab = "output") {
  return { ...createTurnDetailState(), notFound: true, activeTab };
}

export function mergeTurnDetailRecord(currentTurn, nextTurn) {
  if (!nextTurn || !nextTurn.id) {
    return currentTurn;
  }
  if (!currentTurn || !currentTurn.id) {
    return nextTurn;
  }
  return {
    ...currentTurn,
    ...nextTurn,
    state: resolveRunState(currentTurn.state, nextTurn.state)
  };
}

export function selectedTurnArtifact(state) {
  return state.artifacts.find((item) => item.id === state.selectedArtifactID) || null;
}
